import React from "react";
import { ToastContainer } from "react-toastify";
import classes from "../../style/Style.module.css";
import "../../style/Infoscreens.scss";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { useLocation, useNavigate } from "react-router-dom";
import { ROUTE_ACCOUNT_TYPE, ROUTE_DXTER_SCANNING, ROUTE_UPDATED_PORT_FOLIO_SCREEN } from "../../Routes";

const NSeConfirmationWaiting = () => {
  const Navigate = useNavigate();
  const location = useLocation();
  const { reason } = location.state || {};
  console.log(reason);
  const HandleBack = () => {
    Navigate(-1);
  };
  const HandleSubmit = () => {
    Navigate(ROUTE_DXTER_SCANNING);
  };
  return (
    <div className="NSE_Waiting_Main_Container">
      <div className="Header">
        <ArrowBackIosIcon className="Back_btn" onClick={HandleBack} />
      </div>
      <div>
        <p className="Input_Heading_text">
        We are waiting for confirmation from NSE.<br/> Please check after some time. 
        </p>
        <button className="Submit_button" onClick={HandleSubmit}>
        Proceed
      </button>
      </div>
      <ToastContainer />
    </div>
  );
};


export default NSeConfirmationWaiting;